// Б.1.d: Списанный дрон — passive «На него можно вешать до 3-х Модификаций».
// Порог Перегрузки = 4 (вместо дефолта 3). Применяется на onSummon.

export const CARD_ID = 'syn_spisany_dron';

export function spisannyyDronOnSummon(card) {
  if (card?.id !== CARD_ID) return;
  card.overloadThreshold = 4;
}
